/**
 * Browser-safe vocabulary the patient merge contracts compose (PD-1986). Named `.schema.ts` so the
 * web bundlers' `fail-on-server-imports` plugin lets it cross the package boundary: plain consts and
 * types only, no imports. `patient-merge.constants.ts` re-exports these for middleware code.
 */

export const DUPLICATE_REASONS = [
  'dob-phone',
  'dob-email',
  'dob-similar-name',
  'similar-name-phone',
  'similar-name-address',
  'manual',
] as const
export type DuplicateReason = (typeof DUPLICATE_REASONS)[number]

export const MERGE_STATES = ['merging', 'merged', 'restoring', 'restored', 'deleted'] as const
export type MergeState = (typeof MERGE_STATES)[number]

export const MERGE_FIELDS = ['name', 'birthDate', 'gender', 'phone', 'email', 'address'] as const
export type MergeField = (typeof MERGE_FIELDS)[number]
